<template>
  <div>
    <header>
      <navigation theme="light" favourite-theme="light"/>
    </header>
  </div>
</template>

<script>
  import Navigation from './Navigation.vue'

  export default {
    name: 'SiteHeader',
    components: {
      Navigation
    }
  }
</script>
